import { ODSColumn, ODSTabElement, ODSTabs } from '@telekom-ods/react-ui-kit';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import OrganizationBreadCrumb from '../OrganizationDetails/OrganizationBreadCrumb';
import Organizations from '../Organizations';

import Users from './Users';

const GovernanceTabs = () => {
  const intl = useIntl();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const activeTab = () => {
    if (pathname.startsWith('/governance/products')) return 'products';
    if (pathname.startsWith('/governance/users')) return 'users';
    return 'organizations';
  };

  return (
    <>
      <OrganizationBreadCrumb />
      <ODSTabs
        className='ODS-tabs'
        divider
      >
        <ODSTabElement
          text={intl.formatMessage({ id: 'organizations' })}
          selected={activeTab() === 'organizations'}
          onClick={event => {
            event.preventDefault();
            navigate('/governance/organizations');
          }}
        >
          <ODSColumn>
            <Organizations />
          </ODSColumn>
        </ODSTabElement>
        <ODSTabElement
          text={intl.formatMessage({ id: 'users' })}
          selected={activeTab() === 'users'}
          onClick={event => {
            event.preventDefault();
            navigate('/governance/users');
          }}
          size='large'
          variant='fill'
        >
          <ODSColumn
            style={{
              width: '100%',
            }}
          >
            <Users />
          </ODSColumn>
        </ODSTabElement>
      </ODSTabs>
    </>
  );
};

export default GovernanceTabs;
